<template>
  <a-modal
    v-model:visible="visible"
    :title="t('workspaceSettings.identifiers.createModal.title')"
    :on-before-ok="handleBeforeOk"
    @cancel="handleCancel"
  >
    <a-form ref="formRef" :model="form" layout="vertical">
      <a-form-item
        field="name"
        :label="t('workspaceSettings.identifiers.createModal.name')"
        :rules="nameRules"
        validate-trigger="input"
      >
        <a-input
          v-model="form.name"
          :placeholder="
            t('workspaceSettings.identifiers.createModal.namePlaceholder')
          "
          allow-clear
        />
        <template #help>
          {{ t('workspaceSettings.identifiers.createModal.nameHelp') }}
        </template>
      </a-form-item>
      <a-form-item
        field="description"
        :label="t('workspaceSettings.identifiers.createModal.desc')"
      >
        <a-input
          v-model="form.description"
          :placeholder="
            t('workspaceSettings.identifiers.createModal.descPlaceholder')
          "
          allow-clear
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
  import { ref, reactive, computed } from 'vue';
  import Message from '@/utils/message';
  import { useI18n } from 'vue-i18n';
  import { createProtocolApi } from '@/api/protocol';
  import { useUserStore } from '@/store';

  const emit = defineEmits<{
    (e: 'success'): void;
  }>();

  const visible = defineModel('visible', { type: Boolean, default: false });

  const { t } = useI18n();
  const userStore = useUserStore();
  const formRef = ref();
  const form = reactive({
    name: '',
    description: '',
  });

  const nameRules = computed(() => [
    {
      required: true,
      message: t('workspaceSettings.identifiers.createModal.nameRequired'),
    },
    {
      match: /^[a-zA-Z][a-zA-Z0-9_]*$/,
      message: t('workspaceSettings.identifiers.createModal.namePattern'),
    },
  ]);

  const handleCancel = () => {
    visible.value = false;
    formRef.value?.resetFields();
  };

  const handleBeforeOk = async () => {
    const errors = await formRef.value?.validate();
    if (errors) return false;

    try {
      await createProtocolApi({
        name: form.name,
        description: form.description,
        tenant_uuid: userStore.tenantUuid!,
        workspace_uuid: userStore.workspaceUuid!,
      });
      Message.success(
        t('workspaceSettings.identifiers.message.createdSuccess')
      );
      emit('success');
      formRef.value?.resetFields();
      return true;
    } catch (error) {
      return false;
    }
  };
</script>
